import { LocaleId } from '@domgen/dgx-fe-i18n';
import { TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n/lib/models/translation-dictionary/translation-dictionary-mapping.type';
import { FeatureProtectionDetailsTranslationDictionary } from './feature-protection-details-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureProtectionDetailsTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      PROTECTION_ADDITIONAL_QUOTE_MODAL_EXTEND_BUTTON:
        'Register with extra coverage',
      PROTECTION_ADDITIONAL_QUOTE_MODAL_NOT_EXTEND_BUTTON:
        'No thanks, register only',
      PROTECTION_DETAILS_CANCEL_ANYTIME_MONTHLY:
        'Flexible monthly plan, cancel anytime.',
      PROTECTION_DETAILS_CANCEL_ANYTIME_ANNUAL:
        'Flexible prepaid plan, cancel anytime',
      PROTECTION_DETAILS_CANCEL_OBSERVATION:
        'Applicable taxes calculated during checkout.',
      PROTECTION_DETAILS_FORM_SUBMIT: 'Continue',
      PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE:
        'Get 50% off Coverage For 2 Months! Limited Time Only.',
      PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_CTA: 'Pay {{ monthlyOrAnnual }}',
      PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_DISCLAIMER:
        'Applicable taxes calculated during checkout.',
      PROTECTION_DETAILS_REGISTER_WITHOUT_COVER_CTA: 'Register only',
      PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE_MODAL:
        "Don't miss out on your 50% discount",
      PROTECTION_DETAILS_MODAL_TITLE_LAST_CHANCE:
        'Last chance to get protected',
      PROTECTION_DETAILS_MODAL_TITLE_ANNUAL:
        'Or would you like to pay annually?',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_REFUSED_BUTTON_TITLE:
        'Register without Appliance Care',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_SUCCESS_BUTTON_TITLE:
        'Register with Appliance Care',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_WITH_COVER_TITLE:
        'Yes, protect my appliance!​',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_WITHOUT_COVER_TITLE:
        'No, register only',
      PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT:
        'Add {{ brandName }} Appliance Care',
      PROTECTION_DETAILS_QUOTE_OFFER_PRICE: ' for {{ quotePayment }} a month',
      PROTECTION_DETAILS_CURRENT_WARRANTY: 'Current Warranty',
      PROTECTION_DETAILS_CHOOSE_PAYMENT_METHOD: 'Choose how you want to pay',
      PROTECTION_DETAILS_QUOTE_EXTRA_COVERAGE: 'Extra Coverage',
      PROTECTION_DETAILS_QUOTE_OFFER_PROMOTIONAL_BADGE: '50% OFF FOR 2 MONTHS',
      PROTECTION_DETAILS_NEW_MESSAGE: 'New',
      PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_ANNUALLY:
        'Offer - Same Discount, Pay Annually',
      PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_MONTHLY:
        'Offer - 50% off for 2 months',
    },
    [LocaleId.English_Ireland]: {
      PROTECTION_ADDITIONAL_QUOTE_MODAL_EXTEND_BUTTON:
        'Register with extra coverage',
      PROTECTION_ADDITIONAL_QUOTE_MODAL_NOT_EXTEND_BUTTON:
        'No thanks, register only',
      PROTECTION_DETAILS_CANCEL_ANYTIME_MONTHLY:
        'Flexible monthly plan, cancel anytime.',
      PROTECTION_DETAILS_CANCEL_ANYTIME_ANNUAL:
        'Flexible prepaid plan, cancel anytime',
      PROTECTION_DETAILS_CANCEL_OBSERVATION:
        'Applicable taxes calculated during checkout.',
      PROTECTION_DETAILS_FORM_SUBMIT: 'Continue',
      PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE:
        'Get 50% off Coverage For 2 Months! Limited Time Only.',
      PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_CTA: 'Pay {{ monthlyOrAnnual }}',
      PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_DISCLAIMER:
        'Applicable taxes calculated during checkout.',
      PROTECTION_DETAILS_REGISTER_WITHOUT_COVER_CTA: 'Register only',
      PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE_MODAL:
        "Don't miss out on your 50% discount",
      PROTECTION_DETAILS_MODAL_TITLE_LAST_CHANCE:
        'Last chance to get protected',
      PROTECTION_DETAILS_MODAL_TITLE_ANNUAL:
        'Or would you like to pay annually?',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_REFUSED_BUTTON_TITLE:
        'Register without Appliance Care',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_SUCCESS_BUTTON_TITLE:
        'Register with Appliance Care',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_WITH_COVER_TITLE:
        'Yes, protect my appliance!​',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_WITHOUT_COVER_TITLE:
        'No, register only',
      PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT:
        'Add {{ brandName }} Appliance Care',
      PROTECTION_DETAILS_QUOTE_OFFER_PRICE: ' for {{ quotePayment }} a month',
      PROTECTION_DETAILS_CURRENT_WARRANTY: 'Current Warranty',
      PROTECTION_DETAILS_CHOOSE_PAYMENT_METHOD: 'Choose how you want to pay',
      PROTECTION_DETAILS_QUOTE_EXTRA_COVERAGE: 'Extra Coverage',
      PROTECTION_DETAILS_QUOTE_OFFER_PROMOTIONAL_BADGE: '50% OFF FOR 2 MONTHS',
      PROTECTION_DETAILS_NEW_MESSAGE: 'New',
      PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_ANNUALLY:
        'Offer - Same Discount, Pay Annually',
      PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_MONTHLY:
        'Offer - 50% off for 2 months',
    },
    [LocaleId.English_US]: {
      PROTECTION_ADDITIONAL_QUOTE_MODAL_EXTEND_BUTTON:
        'Register with extra coverage',
      PROTECTION_ADDITIONAL_QUOTE_MODAL_NOT_EXTEND_BUTTON:
        'No thanks, register only',
      PROTECTION_DETAILS_CANCEL_ANYTIME_MONTHLY:
        'Flexible monthly plan, cancel anytime.',
      PROTECTION_DETAILS_CANCEL_ANYTIME_ANNUAL:
        'Flexible prepaid plan, cancel anytime',
      PROTECTION_DETAILS_CANCEL_OBSERVATION:
        'Applicable taxes calculated during checkout.',
      PROTECTION_DETAILS_FORM_SUBMIT: 'Continue',
      PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE:
        'Get 50% off Coverage For 2 Months! Limited Time Only.',
      PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_CTA: 'Pay {{ monthlyOrAnnual }}',
      PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_DISCLAIMER:
        'Applicable taxes calculated during checkout.',
      PROTECTION_DETAILS_REGISTER_WITHOUT_COVER_CTA: 'Register only',
      PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE_MODAL:
        "Don't miss out on your 50% discount",
      PROTECTION_DETAILS_MODAL_TITLE_LAST_CHANCE:
        'Last chance to get protected',
      PROTECTION_DETAILS_MODAL_TITLE_ANNUAL:
        'Or would you like to pay annually?',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_REFUSED_BUTTON_TITLE:
        'Register without Appliance Care',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_SUCCESS_BUTTON_TITLE:
        'Register with Appliance Care',
      PROTECTION_DETAILS_QUOTE_OFFER_PROMOTIONAL_BADGE: '50% OFF FOR 2 MONTHS',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_WITH_COVER_TITLE:
        'Yes, protect my appliance!​',
      PROTECTION_DETAILS_SINGLE_REGISTRATION_WITHOUT_COVER_TITLE:
        'No, register only',
      PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT:
        'Add {{ brandName }} Appliance Care',
      PROTECTION_DETAILS_QUOTE_OFFER_PRICE: ' for {{ quotePayment }} a month',
      PROTECTION_DETAILS_CURRENT_WARRANTY: 'Current Warranty',
      PROTECTION_DETAILS_CHOOSE_PAYMENT_METHOD: 'Choose how you want to pay',
      PROTECTION_DETAILS_QUOTE_EXTRA_COVERAGE: 'Extra Coverage',
      PROTECTION_DETAILS_NEW_MESSAGE: 'New',
      PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_ANNUALLY:
        'Offer - Same Discount, Pay Annually',
      PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_MONTHLY:
        'Offer - 50% off for 2 months',
    },
  };
